module.exports = __webpack_public_path__ + "static/img/170810-team-and-grail-.dc3af94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/170810-team-and-grail-.jpg
// module id = MSBL
// module chunks = 0